/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AIDetection, AIDetection$inboundSchema } from "./aidetection.js";

export type ListAIDetectionsResult = {
  /**
   * Detected AI tools aggregated per target, most recently seen first.
   */
  detections: Array<AIDetection>;
};

/** @internal */
export const ListAIDetectionsResult$inboundSchema: z.ZodMiniType<
  ListAIDetectionsResult,
  unknown
> = z.object({
  detections: z.array(AIDetection$inboundSchema),
});

export function listAIDetectionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAIDetectionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAIDetectionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAIDetectionsResult' from JSON`,
  );
}
